import { render, staticRenderFns } from "./entity-table-input.vue?vue&type=template&id=2481363b&scoped=true&"
import script from "./entity-table-input.ts?vue&type=script&lang=ts&"
export * from "./entity-table-input.ts?vue&type=script&lang=ts&"
import style0 from "./entity-table-input.scss?vue&type=style&index=0&id=2481363b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481363b",
  null
  
)

export default component.exports